/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frends.vue?vue&type=template&id=19646170&scoped=true"
import script from "./frends.vue?vue&type=script&lang=js"
export * from "./frends.vue?vue&type=script&lang=js"
import style0 from "./frends.vue?vue&type=style&index=0&id=19646170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19646170",
  null
  
)

export default component.exports